const locale = {
  placeholder: 'è«é¸ææé',
};

export default locale;
